<template>
  <div class="widget widget-my-kits box box--shadow">
      <header class="row">
        <div class="col-6"><h3>My Kits</h3></div>
        <div class="col-6"><router-link to="/kits" class="viewAll">View all</router-link></div>
      </header>
      
    <ul>
      <li><span class="count text-cyan">{{totalKits}}</span> Total Kits</li>
      <li><span class="count text-orange">{{unassignedKits}}</span> Available Kits</li>
  </ul>
  </div>
</template>

<script>
export default {
  name: 'widget-my-kits',
  props: ['totalKits', 'unassignedKits']
}
</script>

<style scoped lang='scss'>
header{
    margin-bottom: 0 !important;
    a {
        text-align: right;
        display: block;
        font-style: italic;
    }
}
ul{
    padding-left: 0;
    list-style: none;
    margin: 0;
    li{
        padding: 15px;
        background: #F4F4F4;
        margin-bottom: 6px;
        .count {
            background: white;
            border-radius: 99em;
            width: 50px;
            height: 50px;
            line-height: 50px;
            display: inline-block;
            text-align: center;
            font-family: "athelas", serif;
            font-size: 24px;
            font-style: italic;
            margin-right: 10px;
        }
    }
}
</style>
 


// WEBPACK FOOTER //
// src/components/widgets/widget-my-kits.vue